export const CLEAR_TIMER = "CLEAR_TIMER";
export const EDIT_TIMER = "EDIT_TIMER";
export const TOGGLE_DARKMODE = "TOGGLE_DARKMODE";
export const TIMER_TICK = "TIMER_TICK";
